import { SearchMaskFeatureFlags } from '@webc/meeseeks-ui-sdk/build/types/definitions/components/SearchMaskFeatures';

export const FEATURE_DISTRIBUSION = 'feature.enable_distribusion';
export const FEATURE_ONLY_TRAIN_CITIES = 'feature.train_cities_only';

export const features: Partial<{ [key in SearchMaskFeatureFlags]: boolean }> = {
  [FEATURE_DISTRIBUSION]: true,
  [FEATURE_ONLY_TRAIN_CITIES]: false,
};

export const featuresToggledByCookies: {
  [flag in SearchMaskFeatureFlags]?: {
    cookieName: string;
    isEnabled: (cookieValue?: string) => boolean;
  };
} = {
  [FEATURE_DISTRIBUSION]: {
    cookieName: 'search_distribusion',
    isEnabled: (cookieValue?: string) => cookieValue === '1',
  },
};
